export default __webpack_public_path__ + "static/media/Set1_Board3.5f77662b.png";